import React, { FC, useCallback } from 'react';

const InlineHyperlink: FC<any> = ({ path, text }) => {
	const onLinkClick = useCallback(() => window.open(path, '_blank', 'noreferrer'), [path]);

	return (
		<span
			className="cursor-pointer whitespace-nowrap text-blue-600 underline hover:text-blue-800"
			onClick={onLinkClick}
		>
			{text}
		</span>
	);
};

export default InlineHyperlink;
